<template>
    <Modal
        class="NewGroup"
        :opened="isOpen"
        :title="'New Group'"
        :dissmisable="true"
        @close="closeModal"
    >
        <template #body>
            <div class="NewGroupBody">
                <div class="GroupData">
                    <div class="GroupName">
                        <WText
                            :size="12"
                            color="gray02"
                            class="GroupPropLabel"
                        >
                            {{ $t('schema.groups.name') }}
                        </WText>
                        <WInput
                            v-model="groupName"
                            name="GroupName"
                            type="text"
                            :placeholder="'New Group Name'"
                        />
                    </div>
                    <div class="GroupIcon">
                        <WText
                            :size="12"
                            color="gray02"
                            class="GroupPropLabel"
                        >
                            {{ $t('schema.groups.icon') }}
                        </WText>
                        <WIconSelect
                            :value="groupIcon"
                            :options="iconsOptions"
                            @input="groupIcon = $event"
                        />
                    </div>
                </div>
                <div
                    v-if="creating"
                    class="NewGroupActions"
                >
                    <WText
                        :size="16"
                        color="accent-blue"
                        weight="bold"
                        class="Creating"
                    >
                        {{ $t('schema.groups.creating') }}
                    </WText>
                </div>
                <div
                    v-else
                    class="NewGroupActions"
                >
                    <WButton
                        outline
                        color="accent-blue"
                        @click="closeModal"
                    >
                        {{ $t('schema.groups.cancel') }}
                    </WButton>
                    <WButton
                        :disabled="createDisabled"
                        @click="createGroup"
                    >
                        {{ $t('schema.groups.create') }}
                    </WButton>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import VueTypes from 'vue-types'
import { Api, apiRequest } from '@/api'
import { Modal } from '@/components'
import projectIcons from '@/utils/projectIcons'

export default {
    name: 'NewGroupModal',
    components: { Modal },
    props: {
        isOpen: VueTypes.bool,
        entityKey: VueTypes.string,
    },
    data () {
        this.iconsOptions = projectIcons
        return {
            creating: false,
            groupName: '',
            groupIcon: '',
        }
    },
    computed: {
        createDisabled () {
            return !this.groupName || !this.groupIcon
        },
    },
    watch: {
        isOpen (newIsOpen) {
            if (newIsOpen) {
                this.groupName = ''
                this.groupIcon = ''
            }
        },
    },
    methods: {
        closeModal () {
            this.groupName = ''
            this.groupIcon = ''
            this.$emit('close')
        },
        createGroup () {
            this.creating = true
            const { entityKey } = this
            const params = { key: this.groupName, name: this.groupName, icon: this.groupIcon }
            apiRequest(Api().entities.createGroup({ entityKey, params }))
                .then(() => {
                    this.$emit('refreshGroups')
                    this.closeModal()
                })
                .finally(() => { this.creating = false })
        },
    },
}
</script>

<style lang="scss" scoped>
.NewGroup {
    &::v-deep .Dialog {
        overflow: visible;
    }
    .NewGroupBody {
        .GroupData {
            display: flex;
            flex-direction: row;
            gap: 10px;
            .GroupName {
                display: flex;
                flex-direction: column;
                flex: 1;
                .WInput {
                    display: flex;
                    flex: 1;
                    &::v-deep input {
                        height: auto;
                        padding: 0 15px;
                    }
                }
            }
            .GroupIcon {
                width: 15%;
            }
            .GroupPropLabel {
                margin-bottom: 2px;
            }
        }
        .NewGroupActions {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            margin-top: 30px;
            .Creating {
                padding-top: 7px;
                padding-bottom: 7px;
            }
        }
    }
}
</style>
